import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Model from '../models/model';
import strings from '../Globalization';
import Connection from '../services/Connection';
import util from '../util';
import { usePrerequisites } from '../contexts/Prerequisites';

const FileDownload = ({ row = {} }) => {
	const { FileType = '', FileName = '', SerialNumber = '', IsFileDeleted = false } = row;
	const [{csrfTokenMap}] = usePrerequisites()
	const handleDowload = async () => {
		if (IsFileDeleted) {
			util.showError(strings.Filenotfound, strings.Info, 'info');
			return;
		}
		const action = `${Connection.ViewAttachment}?v=${new Date().getTime()}&csrf-token=${csrfTokenMap.get('value')}`;
		const body = {
			action: 'otherAction',
			otherAction: 'download',
			fileType: FileType,
			fileName: FileName,
			serialNumber: SerialNumber
		};
		util.dynamicFormSubmission({ body, action });

	}
	return (
		<Button color="primary" onClick={handleDowload} variant='text'>
			<FileDownloadIcon />
		</Button>
	);
};

const RequestFile = ({ formik: { values: { RequestFile = '' } } }) => {
	const [searchParams] = useSearchParams();
	const equipmentId = searchParams.get('equipmentId') ? searchParams.get('equipmentId') : '';
	const handleClick = async () => {
		if(!RequestFile) {
			util.showError(strings.SelectFile, strings.Info, 'info');
			return;
		}
		const formData = new FormData();
		formData.append('fileType', RequestFile);
		formData.append('equipmentId', equipmentId);
		formData.append('otherAction', 'import');
		formData.append('action', 'otherAction');
		await fetch(Connection.ViewAttachment, {
			method: 'POST',
			body: formData
		}).then(response => response.json())
			.then(res => {
				if (res.success) {
					util.showError(strings.Requestsendsuccessfully, strings.Info, 'success');
				}
			}).catch((err) => {
				util.showError(strings.ExportValidation, strings.Info, 'error');
			})
	}
	return (
		<Button
			variant="contained"
			onClick={handleClick}
			color="success"
			sx={{
				padding: '0px 18px !important',
				height: '40px !important',
			}}
		>
			{strings.Requestfile}
		</Button>
	)
}

 export const model = new Model({
		title: 'Attachments',
		name: 'ViewAttachment',
		idProperty: 'id',
		pageSize: 10,
		disableColumns: true,
		disableDelete: true,
		disableAdd: true,
		disableExport: true,
		disableFiltering: true,
		hideGridFooter: true,
		gridRefreshInterval: 5000,
		headerFilterApplyTrigger: 'onChange',
		showGridRefreshBtn: true,
		columns: [
			{ 
				field: 'RequestFile',
				width: 120,
				isNotformfield: true,
				headerFilter: true,
				lookup: 'RequestFile',
				eager: true,
				headerFilterProps: { label: 'Requestfile', multiple: false },
				standaloneHeaderFilter: true,
				readOnly: true,
				filterColSize: 4,
				headerFilterSiblingComponents: [
					RequestFile
				]
			},
			{ field: 'FileName', header: 'File Name', readOnly: true, width: 150 },
			{ field: 'DateSent', header: 'Date Sent', readOnly: true, type: 'dateTime', width: 170, isLocal: true },
			{
				field: 'Download',
				header: 'Download',
				hideLabel: true,
				renderCell: FileDownload
			}
		]
 });

export default model.createFormBase();